module.exports = __webpack_public_path__ + "static/jaime-3eeea1086150f6bd371fb6706500c517.jpg";